<template>
  <div
    v-if="showCTA"
    class="insights-cta-banner-workforce-wrapper"
  >
    <InsightsCTABanner
      type="workforce"
      :is-loading="isLoading"
      :hide-action-button="false"
      @hide="hideCTA"
      @showDialog="toggleDialog"
      @submit="submitCTA"
      @close="closeCTA"
    />
    <InsightsCTABannerDialog
      v-if="showDialog"
      :show="showDialog"
      type="workforce"
      @close="toggleDialog"
    />
  </div>
</template>

<script>
import InsightsCTABanner from '~/components/insights/InsightsCTABanner.vue';
import InsightsWorkforceBanner from '~/mixins/InsightsWorkforceBanner';

export default {
  name: 'DashboardWorkforceBanner',
  components: {
    InsightsCTABanner,
    InsightsCTABannerDialog: () => import('~/components/insights/InsightsCTABannerDialog.vue'),
  },
  mixins: [InsightsWorkforceBanner],
  props: {
    initialState: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showCTA: this.initialState.show_insights_banner,
      isLoading: false,
      showDialog: false,
      dismiss: false,
      url: this.initialState.insights_url,
    };
  },
  methods: {
    toggleDialog(show = false) {
      this.showDialog = show;
      this.dismissCTA();
    },
    async submitCTA() {
      this.isLoading = true;
      // Await persistence before navigating away, or the page unload cancels the in-flight request.
      await this.dismissCTA();
      window.location.href = this.url;
    },
    closeCTA() {
      this.dismissCTA();
      this.showCTA = false;
    },
    hideCTA(dismiss) {
      this.dismiss = dismiss;
    },
    dismissCTA() {
      if (this.dismiss) {
        return this.dismissInsightsWorkforceBanner();
      }

      return Promise.resolve();
    },
  },
};
</script>
